import { render, staticRenderFns } from "./Ebook-Paper.vue?vue&type=template&id=5ffd1cd6&"
import script from "./Ebook-Paper.vue?vue&type=script&lang=js&"
export * from "./Ebook-Paper.vue?vue&type=script&lang=js&"
import style0 from "./Ebook-Paper.vue?vue&type=style&index=0&id=5ffd1cd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports